<template>
  <div class="multi-section-container">
    <component
      :is="isCatalogType ? CatalogLoader : DynamicSectionLoader"
      v-on-display="sectionInfo"
      :catalog-info="catalog"
      :section-info="sectionInfo"
      :multisection-index="index"
    />
  </div>
</template>
<script>
  import { computed } from 'vue'
  import { getApiType } from '@/common/util/home/get-api-type'
  import { convertMultiSectionInfo } from '@/common/converter/convert-multi-section-info'
  import { multiSectionConverter } from '@/common/converter/ObjectConverter'
  import { API_TYPE_CATALOG } from '@/common/converter/const'
  import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
  import CatalogLoader from '@/components/section/CatalogLoader.vue'
  import { onDisplay } from '@/common/directives'

  export default {
    components: {
      DynamicSectionLoader,
      CatalogLoader,
    },
    directives: {
      onDisplay,
    },
    props: {
      catalog: {
        type: Object,
        default: null,
      },
      index: {
        type: Number,
        default: 0,
      },
    },
    setup(props) {
      const apiType = computed(
        () => getApiType(props.catalog?.elementList) ?? '',
      )
      const isCatalogType = computed(() => apiType.value === API_TYPE_CATALOG)
      const sectionInfo = computed(() =>
        multiSectionConverter(convertMultiSectionInfo(props.catalog)),
      )

      return {
        apiType,
        isCatalogType,
        sectionInfo,
        DynamicSectionLoader,
        CatalogLoader,
      }
    },
  }
</script>
